import API from "../../../../global/api";


export const requestAllData = () => {
  return {
    type: "REQUEST_ALL_DATA",
  };
};
export const successAllData = (data) => {
  return {
    type: "SUCCESS_ALL_DATA",
    payload: data,
  };
};
export const errorAllData = () => {
  return {
    type: "ERROR_ALL_DATA",
  };
};

export const getAllData = (data) => {
  return (dispatch) => {
     dispatch(requestAllData());
    API.post(`/petitional/get-all-child-data`,data).then((res) => {
      dispatch(successAllData(res.data));
    }).catch((err)=> 
   dispatch(errorAllData())
   );
  };
};


//CHILD RESIDENCE

//API CALL
export const putChildResidence = (data) => {
  return (dispatch) => {
    API.put(`/petitional/child-residence`, data).then((res) => {
      dispatch(successChildResidence(data));
    });
  };
};

//ACTIONS CREATORS

export const requestChildResidence = (data) => {
  return {
    type: "REQUEST_CHILD_RESIDENCE ",
  };
};
export const successChildResidence = (data) => {
  return {
    type: "SUCCESS_CHILD_RESIDENCE",
    payload: data,
  };
};
export const errorChildResidence = (data) => {
  return {
    type: "ERROR_CHILD_RESIDENCE",
    payload: data,
  };
};

//CHILD AGE

//API CALL
export const putChildAge = (data) => {
  return (dispatch) => {
    API.put(`/petitional/child-age`, data).then((res) => {
      dispatch(successChildAge(res.data));
    });
  };
};

//ACTIONS
export const requestChildAge = (data) => {
  return {
    type: "CI_REQUEST_CHILD_AGE ",
  };
};
export const successChildAge = (data) => {
  return {
    type: "CI_SUCCESS_CHILD_AGE",
    payload: data,
  };
};
export const errorChildAge = (data) => {
  return {
    type: "CI_ERROR_CHILD_AGE",
    payload: data,
  };
};


  // delete CHILD

  export const requestDeleteChild = (data) => {
    return {
      type: "REQUEST_DELETE_CHILD",
    };
  };
  export const successDeleteChild = (data) => {
    return {
      type: "SUCCESS_DELETE_CHILD",
      payload: data,
    };
  };
  export const errorDeleteChild = (data) => {
    return {
      type: "ERROR_DELETE_CHILD",
      payload: data,
    };
  };
  
  export const  deleteChildCall = (data) => {
    return (dispatch) => {
      API.post(`/petitional/delete-children-data`,data).then((res) => {
        dispatch(successDeleteChild(res.data));
      }).catch((err)=> 
        dispatch(errorDeleteChild())
      );
    };
  };